import React, { useState, useContext } from "react";
import * as Constants from "../../constants";
import { ShareContext } from "../../context/ShareContext";
import JisDialogForm from "../formdialog";
import JisAlert from "../jisalert";

function VirtualCallAudit({ docId, caseId }) {
  const { token, setIsExpired } = useContext(ShareContext);
  const [virtualCall, setVirtualCall] = useState({
    checked: false,
    startTime: "",
    endTime: "",
  });
  const [alert, setAlert] = useState({ open: false, title: "", subtitle: "" });

  const onOk = () => setAlert((a) => ({ ...a, open: false }));

  const onSubmit = () => {
    const { startTime, endTime } = virtualCall;
    if (!startTime || !endTime) {
      setAlert({
        open: true,
        title: "Virtual Call Audit",
        subtitle: "Please enter both start and end time.",
        onOk,
      });
      return;
    }
    const today = new Date().toDateString();
    const payload = {
      docId,
      caseId: caseId ?? null,
      isVirtual: true,
      startTime: new Date(`${today} ${startTime}`).toISOString(),
      endTime: new Date(`${today} ${endTime}`).toISOString(),
    };
    fetch(`${Constants.apiUrl}/report/trail-virtial-call`, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.code === 0 || data.code === undefined) {
          setVirtualCall({ checked: false, startTime: "", endTime: "" });
          setAlert({
            open: true,
            title: "Virtual Call Audit",
            subtitle: "Zoom session recorded successfully.",
            onOk,
          });
        } else if (data.code === -10) {
          setIsExpired(true);
        } else {
          setAlert({
            open: true,
            title: "Virtual Call Audit",
            subtitle: data.status || "Failed to record session.",
            onOk,
          });
        }
      })
      .catch(() => {
        setAlert({
          open: true,
          title: "Virtual Call Audit",
          subtitle: "An error occurred. Please try again.",
          onOk,
        });
      });
  };

  return (
    <>
      <div className="check-sign" style={{ marginBottom: 16 }}>
        <div className="cfo_input">
          <input
            type="checkbox"
            id="virtual-call-audit"
            checked={virtualCall.checked}
            onChange={(e) =>
              setVirtualCall((v) => ({ ...v, checked: e.target.checked }))
            }
          />
          <label htmlFor="virtual-call-audit">
            Zoom session held with deponent
          </label>
        </div>
      </div>

      {virtualCall.checked && (
        <JisDialogForm
          title="Record Zoom Session"
          onClose={() => setVirtualCall((v) => ({ ...v, checked: false }))}
        >
          <form
            onSubmit={(e) => {
              e.preventDefault();
              onSubmit();
            }}
          >
            <div>
              <div className="input-group">
                <label>Start Time</label>
                <div className="input-wrapper">
                  <input
                    type="time"
                    value={virtualCall.startTime}
                    onChange={(e) =>
                      setVirtualCall((v) => ({
                        ...v,
                        startTime: e.target.value,
                      }))
                    }
                  />
                </div>
              </div>
              <div className="input-group">
                <label>End Time</label>
                <div className="input-wrapper">
                  <input
                    type="time"
                    value={virtualCall.endTime}
                    onChange={(e) =>
                      setVirtualCall((v) => ({ ...v, endTime: e.target.value }))
                    }
                  />
                </div>
              </div>
              <div className="schedule_btn_wrapper">
                <button
                  type="button"
                  onClick={() =>
                    setVirtualCall((v) => ({ ...v, checked: false }))
                  }
                >
                  Cancel
                </button>
                <button type="submit">Record Zoom Session</button>
              </div>
            </div>
          </form>
        </JisDialogForm>
      )}

      {alert.open && <JisAlert {...alert} />}
    </>
  );
}

export default VirtualCallAudit;
